<!--
 * @Author: Lemon C
 * @Date: 2024-05-15 17:46:20
 * @LastEditTime: 2025-01-07 17:01:09
-->
<template>
    <div class="sup-search-comp">
        <SearchTree class="search-tree" :tree_sel_type="tree_sel_type" :tree_list="search_tree_list" :tree_node_callback="tree_node_callback">
        </SearchTree>
        <SearchContComp
            class="search-cont-comp"
            v-if="search_cont_list.length"
            :tree_sel_type="tree_sel_type"
            :search_result_list="search_cont_list"
            :search_highlight_words="search_cont_highlight_words"></SearchContComp>
        <el-empty class="search-cont-comp" v-else description="暂无数据" />
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, getCurrentInstance, watch } from 'vue';
import SearchTree from '@/components/Tree/SearchTree.vue';
import SearchContComp from '@/components/Search/SearchContComp.vue';
import { docSearch } from '@/service/interface';
import { useSearchStore } from '@/stores/search';

const search_store = useSearchStore();

const { proxy } = getCurrentInstance();

const props = defineProps({
    search_keywords: String,
    tree_sel_type: Number,
});

const eltree_sel_data = ref({});
const search_input = ref('');
const search_classify = ref({});
const search_tree_list = ref(proxy.$globalObj.search_tree_list);
const search_cont_list = ref([]);
const search_cont_highlight_words = ref([]);

watch(
    () => props.search_keywords,
    () => {
        service_getDocSearch();
    }
);

onMounted(() => {
    search_input.value = props.search_keywords;
    service_getDocSearch();
});

// MARK Service 获取搜索信息
const service_getDocSearch = () => {
    proxy.$showLoading();
    let param = {
        keyWord: props.search_keywords,
        splitWords: true,
    };
    docSearch(param).then((result) => {
        proxy.$hideLoading();
        search_cont_highlight_words.value = [];
        if (result.isSuccess) {
            service_handleTreeList(result.data.docRecords);
            search_cont_highlight_words.value = result.data.highLightKeyWords;
            if (result.data.highLightKeyWords && result.data.highLightKeyWords.length) search_store.addSearch(props.search_keywords);
        }
    });
};

// MARK Service 目录树数据处理
const service_handleTreeList = (docRecords) => {
    // 分类处理
    let classify = docRecords.reduce((acc, currV) => {
        let { docRecordType } = currV;
        if ([proxy.$globalObj.group.platform, proxy.$globalObj.group.plugin, proxy.$globalObj.group.sdk].includes(docRecordType)) {
            if (!acc[proxy.$globalObj.search_tree_obj.update_id]) {
                acc[proxy.$globalObj.search_tree_obj.update_id] = [];
            }
            acc[proxy.$globalObj.search_tree_obj.update_id].push(currV);
            // if (!acc[proxy.$globalObj.docs_switch.update]) {
            //     acc[proxy.$globalObj.docs_switch.update] = [];
            // }
            // acc[proxy.$globalObj.docs_switch.update].push(currV);
        } else {
            if (!acc[docRecordType]) {
                acc[docRecordType] = [];
            }
            acc[docRecordType].push(currV);
        }
        return acc;
    }, {});
    // classify[proxy.$globalObj.docs_switch.all] = docRecords;
    classify[proxy.$globalObj.search_tree_obj.all_id] = docRecords;
    classify[proxy.$globalObj.search_tree_obj.dev_id] = docRecords.filter((item) => {
        // classify[proxy.$globalObj.docs_switch.center] = docRecords.filter((item) => {
        return (
            search_tree_list.value
                // .find((item) => item.id == proxy.$globalObj.docs_switch.center)
                .find((item) => item.id == proxy.$globalObj.search_tree_obj.dev_id)
                .subCatalogs.map((item) => item.id)
                .includes(item.docRecordType)
        );
    });

    // 构建目录树结构
    tree_list_reset(search_tree_list.value);
    Object.keys(classify).forEach((docRecordType) => {
        let childrens = classify[docRecordType];
        tree_list_count_update(search_tree_list.value, docRecordType, childrens.length);
    });
    search_classify.value = classify;
};

// MARK Tree  数据重置
const tree_list_reset = (list) => {
    list.forEach((item) => {
        item.count = 0;
        if (item.subCatalogs.length > 0) {
            tree_list_reset(item.subCatalogs);
        }
    });
};

// MARK Tree 查找更新数量
const tree_list_count_update = (list, id, count) => {
    for (let i = 0; i < list.length; i++) {
        const item = list[i];
        if (item.id == id) {
            item.count = count;
            return true;
        }
        if (item.subCatalogs.length > 0) {
            if (tree_list_count_update(item.subCatalogs, id, count)) {
                return true;
            }
        }
    }
    return false;
};

// MARK Tree  节点点击
const tree_node_callback = (data, treeList) => {
    eltree_sel_data.value = data;
    service_handleResultList();
};

// MARK Service 搜索列表数据处理
const service_handleResultList = () => {
    search_cont_list.value = search_classify.value[eltree_sel_data.value.id] || [];
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-search-comp {
    position: relative;
    display: flex;
    overflow: hidden;
    background: var(--color-main-light-bg-white);

    .search-tree {
        width: 23%;
        height: 100%;
    }

    .search-cont-comp {
        flex: 1;
    }
}
</style>
